export default __webpack_public_path__ + "static/alex-240-b9a06ce3a9fdca6c51e38d6d2a93df89.png";